import React, {useState } from 'react';
import styled from 'styled-components';

import { SubmenuContainer } from '../../../forms/input_fields/loadStopsInput';
import { AddButton, RemoveButton } from '../../reusableItems/buttons';
import { priceTypingProcess, priceOnFinish } from '../../../../supplementary_components/priceInputDelegate';
import { generateShortId } from '../../../../supplementary_components/supplementaryMethods';
import cloneDeep from 'lodash/cloneDeep';

const Titles = styled.span`
    display:grid;
    gap:0.5rem;
    grid-template-columns: ${props => props.$gridTemplateColumns ? props.$gridTemplateColumns : '1fr 1fr 1fr 1fr'} 1.0rem;
    padding: 0.7rem 0.7rem 0 0.7rem;
    &>:last-child{
        // text-align:right;
    }
    &>span{
        color:var(--light-gray);
        white-space:nowrap;
    }
`

const CheckboxWrap = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    .container {
        display:block;
        position:relative;
        width:1.15rem;
        height:1.15rem;
        cursor:pointer;
        -webkit-user-select:none;
        user-select:none;
    }
    && input[type="checkbox"]{
        position:absolute;
        opacity:0;
        cursor:pointer;
        height:0;
        width:0;
        padding:0;
        margin:0;
        box-shadow:none;
    }
    .checkmark {
        position:absolute;
        top:0;
        left:0;
        height:1.15rem;
        width:1.15rem;
        border-radius:0.2rem;
        background:var(--bg);
        box-shadow: var(--button-outline);
    }
    .container input:checked ~ .checkmark {
        background-color: var(--main-color);
        box-shadow:none;
    }
    .checkmark:after {
        content:"";
        position:absolute;
        display:none;
        left:0.38rem;
        top:0.08rem;
        width:0.29rem;
        height:0.75rem;
        border:solid #fff;
        border-width:0 0.13rem 0.13rem 0;
        transform:rotate(45deg);
    }
    .container input:checked ~ .checkmark:after {
        display:block;
    }
    .container:has(input:disabled) {
        cursor:not-allowed;
    }
    .container input:disabled ~ .checkmark {
        opacity:0.35;
        cursor:not-allowed;
        background:var(--extra-light-gray);
    }
`

const RateField = styled.div`
    position:relative;
    min-width:0;
    .perMileSuffix {
        position:absolute;
        right:0.45rem;
        top:50%;
        transform:translateY(-50%);
        color:var(--light-gray);
        font-size:0.85rem;
        font-weight:600;
        pointer-events:none;
        line-height:1;
    }
`

const exclusiveCheckboxGroups = (structureData) => structureData?.exclusiveCheckboxGroups || [];

const checkboxIsBlocked = (row, field, structureData) => {
    return exclusiveCheckboxGroups(structureData).some(
        (group) => group.includes(field) && group.some((other) => other !== field && !!row?.[other])
    );
};

const normalizeExclusiveCheckboxes = (rows, structureData) => {
    const groups = exclusiveCheckboxGroups(structureData);
    if (!rows) return [];
    if (groups.length === 0) return rows;
    return rows.map((row) => {
        const next = { ...row };
        groups.forEach((group) => {
            const checked = group.filter((field) => !!next[field]);
            checked.slice(0, -1).forEach((field) => {
                next[field] = false;
            });
        });
        return next;
    });
};

const TypeSelect = styled.select`
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background:
        linear-gradient(45deg, transparent 50%, var(--gray) 50%),
        linear-gradient(135deg, var(--gray) 50%, transparent 50%),
        var(--bg);
    background-position:
        calc(100% - 1.15rem) 1.05em,
        calc(100% - 0.75rem) 1.05em,
        0 0;
    background-size:
        0.42rem 0.34rem,
        0.42rem 0.34rem,
        100% 100%;
    background-repeat: no-repeat;
    padding-right: 1.6rem !important;
    cursor: pointer;
    option {
        background: var(--bg);
    }
`

const isHiddenTemplateField = (field) => field.includes('hiddenField') || field === 'id';

export const DriverWeeklyDeductionsEditor = ({data, type, structureData, gridTemplateColumns, titleGridTemplateColumns})=> { 
    const [installments, setInstallments] = useState(() => normalizeExclusiveCheckboxes(cloneDeep(data) || [], structureData))
    const changeFieldVal = (e, fieldName, newVal, onBlur, moneyField)=>{
        const data = [...installments]
        const index = parseInt(e.target.parentElement.parentElement.getAttribute('data-index'));
        data[index][fieldName] = newVal;
        
        setInstallments(data);
        if(onBlur){
            if(e.target.className.includes('subError') ){
                if(e.target.value !== ''){
                    e.target.className = e.target.className.replace('subError', '')
                }
            }
            e.target.value = moneyField && newVal !== ''? priceOnFinish(newVal) : newVal;
        }else{
            e.target.value = moneyField && newVal !== ''? priceTypingProcess(newVal) : newVal;
        }
    }
    return <SubmenuContainer  >
        {installments && installments.length > 0 ?
             <Titles $gridTemplateColumns={titleGridTemplateColumns || gridTemplateColumns}> 
                {
                    structureData.labels.map((val, index)=>{
                        const checkboxHeader = structureData.checkboxField && structureData.checkboxField[index + 1];
                        return <span key={index} style={checkboxHeader ? {textAlign: 'center'} : undefined}>{val}</span>
                    })
                }
            </Titles>
            : null
        }
       
        { 
            installments ?
            installments.map((value, index) => {
                return <div key={index} id={`${type}Block`} data-index={index} className='noPadding'>
                    <span style={{gridTemplateColumns:`${gridTemplateColumns} 1.0rem`}} data-index={index}>
                        {Object.keys(structureData.template).map((field, indx) =>{
                            if(isHiddenTemplateField(field))return <input key={indx} name={field} className="hiddenField" defaultValue={value[field]} />;
                            if(structureData.checkboxField && structureData.checkboxField[indx]){
                                const blocked = checkboxIsBlocked(value, field, structureData);
                                return <CheckboxWrap key={indx}>
                                    <label className="container">
                                        <input
                                            type="checkbox"
                                            name={field}
                                            checked={!!value[field] && !blocked}
                                            disabled={blocked}
                                            onChange={(e)=>{
                                                const next = [...installments];
                                                const row = e.target.closest('[data-index]');
                                                const rowIndex = parseInt(row?.getAttribute('data-index'));
                                                if (Number.isNaN(rowIndex)) return;
                                                next[rowIndex][field] = e.target.checked;
                                                if (e.target.checked) {
                                                    exclusiveCheckboxGroups(structureData).forEach((group) => {
                                                        if (!group.includes(field)) return;
                                                        group.forEach((other) => {
                                                            if (other === field) return;
                                                            next[rowIndex][other] = false;
                                                            const otherInput = row.querySelector(`input[type="checkbox"][name="${other}"]`);
                                                            if (otherInput) otherInput.checked = false;
                                                        });
                                                    });
                                                }
                                                setInstallments([...next]);
                                            }}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                </CheckboxWrap>
                            }
                            if(structureData.selectField && structureData.selectField[indx]){
                                const options = structureData.selectOptions?.[field] || [];
                                return <TypeSelect
                                    key={indx}
                                    name={field}
                                    defaultValue={value[field] || options[0]?.value || ""}
                                    onChange={(e)=>{
                                        const next = [...installments];
                                        const row = e.target.closest('[data-index]');
                                        const rowIndex = parseInt(row?.getAttribute('data-index'));
                                        if (Number.isNaN(rowIndex)) return;
                                        next[rowIndex][field] = e.target.value;
                                        setInstallments(next);
                                    }}
                                >
                                    {options.map((option) => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </TypeSelect>
                            }
                            const textInput = <input key={field === 'weeklyRate' ? undefined : indx} name={field} data-mandatory={true} data-parse-float={structureData.moneyField[indx]}
                                style={field === 'weeklyRate' && value.perMile ? {paddingRight: '1.9rem'} : undefined}
                                onChange={(e)=>{
                                    changeFieldVal(e, field, e.target.value, false, structureData.moneyField[indx])
                                }} 
                                onBlur={(e)=>{
                                    changeFieldVal(e, field, e.target.value, true, structureData.moneyField[indx])
                                }}
                                defaultValue={structureData.moneyField[indx] && value[field] !== '' && typeof(value[field]) === "number"? priceOnFinish(`${value[field]}`) : value[field]}
                            />
                            if (field === 'weeklyRate') {
                                return <RateField key={indx}>
                                    {textInput}
                                    {value.perMile ? <span className="perMileSuffix">/mi</span> : null}
                                </RateField>
                            }
                            return textInput;
                        })}
                        
                        <RemoveButton action={
                            (e)=>{
                                installments.splice(parseInt(e.target.parentElement.parentElement.parentElement.getAttribute('data-index')), 1)
                                setInstallments([...installments]);
                            }}/>
                    </span>
                    
                </div>
            })
            :null
        }
        <div className="addButton removePadding">
            <AddButton customSize={"1.4rem"} inactive={false}  action={()=>{
                const next = cloneDeep(structureData.template);
                if ('id' in next) next.id = generateShortId();
                if ('hiddenFieldId' in next) next.hiddenFieldId = generateShortId();
                setInstallments([...installments, next])
            }} />
        </div>
        
        
    </SubmenuContainer>
}
